import { useState } from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleDown } from '@fortawesome/free-solid-svg-icons'

function SidebarItem({
  icon,
  label,
  isActive = false,
  link,
  onClick,
  hasDropdown = false,
  dropdownItems = []
}) {
  const [isOpen, setIsOpen] = useState(false)

  const toggleDropdown = (e) => {
    if (hasDropdown) {
      e.preventDefault()
      setIsOpen(!isOpen)
    }
  }

  // ------------------------------
  // Render Dropdown Version
  // ------------------------------
  if (hasDropdown) {
    return (
      <div className="sidebar-item-wrapper">
        <div
          className={`sidebar-item ${isActive ? 'active' : ''}`}
          onClick={toggleDropdown}
          style={{ cursor: 'pointer' }}
        >
          <span className="me-2">{icon}</span>
          <span>{label}</span>

          <span className="ms-auto">
            <FontAwesomeIcon
              icon={isOpen ? faAngleDown : faAngleRight}
              style={{ fontSize: '14px' }}
            />
          </span>
        </div>

        {isOpen && (
          <div className="d-flex flex-column my-1">
            {dropdownItems.map((item, index) => (
              <Link
                key={index}
                to={item.link}
                className={`sidebar-item-dropdown ${item.isActive ? 'active' : ''}`}
                onClick={item.onClick}
              >
                <span className="me-1">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    )
  }

  // ------------------------------
  // Render Normal Item
  // ------------------------------
  if (label !== "Admin") {
    return (
      <Link
        to={link}
        className={`sidebar-item ${isActive ? 'active' : ''}`}
        onClick={onClick}
      >
        <span className="me-2">{icon}</span>
        <span>{label}</span>
      </Link>
    )
  }else{
    return (
      <a
        href={`${process.env.REACT_APP_API_URL}xxebrifo_admin/`}
        className={`sidebar-item ${isActive ? 'active' : ''}`}
        onClick={onClick}
      >
        <span className="me-2">{icon}</span>
        <span>{label}</span>
      </a>
    )
  }

  // If label is not Admin, render nothing or extend here if needed
  return null
}

export default SidebarItem
